export enum UnsubscribeReport {
  INDEX = '/unsubscribe-report',
}
